import "./App.css";
import { useTranslation } from "react-i18next";
import { RentForm2026 } from "./RentForm2026";
import { SharedResult } from "./components/SharedResult";
import { OGImagePage } from "./components/OGImagePage";
import { StatsPage } from "./components/StatsPage";

const lngs = [
  { code: "fr", native: "Français" },
  { code: "en", native: "English" },
  
];

export default function App() {
  const { i18n } = useTranslation();
  const locationPath = (() => {
    if (typeof window === 'undefined') return '';
    const { pathname, hash } = window.location;
    if (hash && hash.startsWith('#/')) {
      return `${pathname}${hash.slice(1)}`;
    }
    return `${pathname}${hash || ''}`;
  })();
  const isSharedView = locationPath.includes('/resultat');
  const isOgImageView = locationPath.includes('/ogimage');
  const isStatsView = locationPath.includes('/stats');

  const handleTrans = (code) => {
    i18n.changeLanguage(code);
  };

  return (
    <div className="app bg-[#fbf8f4] px-4 sm:px-10" key="app">
      <header className="app-header">
        <div key="lang-switcher" className="lang-switcher hidden">
          {lngs.map((lng) => {
            const { code, native } = lng;
            return (
              <button
                key={native}
                className={`${i18n.resolvedLanguage === code ? 'active' : ''}`}
                onClick={() => handleTrans(code)}
              >
                {native}
              </button>
            );
          })}
        </div>
      </header>
      {isOgImageView ? <OGImagePage /> : isStatsView ? <StatsPage /> : isSharedView ? <SharedResult /> : <RentForm2026 />}
      
    </div>
  );
}
